/* RESPONSIBLE TEAM: team-ai-agent */
import Controller from '@ember/controller';

export default class SettingsAIAutomationFinAiAgentController extends Controller {
  queryParams = ['section'];
}
